module.exports = __webpack_public_path__ + "img/Andaluza-6-min.6e4be9ee.jpg";